var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/project.template.html');

var TheView = GenericView.extend({
    el: '#project',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "project");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
    },
    events: {
        "change input.slider": "fillTextBoxWithSliderValue",
        "input .input-slider": "changeSliderValue",
        "input .to-validation input": "validateIt"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    fillTextBoxWithSliderValue: function(event) {
        $input_id = $(event.currentTarget).data("input-id");
        $input_value = $(event.currentTarget).val();
        $("#" + $input_id).val($input_value);
    },
    changeSliderValue: function(event) {
        var slider_data_id = $(event.currentTarget).attr('id');
        var input_value = $(event.currentTarget).val();
        $('[data-input-id="' + slider_data_id + '"]').val(input_value);
    },
    getAllData: function() {
     var data = {
         project_lifetime: this.convertToInt("#project_lifetime"),
         project_subsidy: this.convertToFloat("#project_subsidy"),
         project_int_r: this.convertToFloat("#project_int_r"),
         project_inf_r: this.convertToFloat("#project_inf_r"),
         project_e_inf_r: this.convertToFloat("#project_e_inf_r")
     };

     return data;
    }
});

module.exports= TheView;